import React, { Component } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'

import { media } from 'styles/media'
import { white } from 'styles/colors'
import { animationTime, animationCurve } from 'styles/global'
import { H1, fontWeights, Lead } from 'styles/typography'
import Icon from 'components/Icon'
import * as spacing from 'styles/spacing'

import LeftChevron from 'icons/left-chevron.svg'
import RightChevron from 'icons/right-chevron.svg'

const Container = styled.div`
  position: relative;

  .slick-dots li {
    display: none;

    span {
      width: 10px;
      display: inline-block;
      font-weight: ${fontWeights.bold};
    }

    &.slick-active {
      display: block;

      &:after {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 84px;
        height: 1px;
        background-color: ${white};
        margin: 0 ${spacing.small};

        ${media.medium`
          width: 60px;
          margin: 0 ${spacing.medium};
        `};
      }
    }
  }
`

const Inner = styled.div`
  position: static;
  padding: 0 48px;
`

const Heading = styled(H1)`
  display: block;
  position: relative;
  color: ${white};
  font-family: 'Trim Poster';
  text-transform: uppercase;
  font-size: 48px;
  letter-spacing: 0.05em;
  margin-bottom: 0.75em;
  margin-left: auto;
  margin-right: auto;
  max-width: 300px;

  ${media.small`
    font-size: 54px;
    max-width: none;
  `};

  ${media.medium`
    font-size: 60px;
  `};

  ${media.large`
    font-size: 66px;
    margin-bottom: 1em;
  `};

  ${media.xLarge`
    font-size: 72px;
  `};
`

const HeadingLabel = styled.span`
  position: static;
`

const Description = styled(Lead)`
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  color: ${white};

  ${media.small`
    max-width: 440px;
  `};

  ${media.medium`
    max-width: 660px;
  `};
`

const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${white};
  margin-top: 40px;

  ${media.small`
    margin-top: 48px;
  `};

  ${media.large`
    margin-top: 60px;
  `};

  ${media.xLarge`
    margin-top: 72px;
  `};
`

const ArrowWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  transform: translateY(-100%);
  padding: 0 10vw;
  margin-left: auto;
  margin-right: auto;

  ${media.small`
    padding: 0;
    width: 360px;
  `};

  ${media.medium`
    width: 840px;
    transform: translateY(-120px);
  `};

  ${media.large`
    transform: translateY(-134px);
  `};

  ${media.xLarge`
    transform: translateY(-148px);
  `};
`

const Arrow = styled.button`
  display: flex;
  cursor: pointer;
  z-index: 20;
  transition: color ${animationTime} ${animationCurve};
  color: ${white};
  padding: ${spacing.small};
  margin: -${spacing.small};

  ${media.medium`
    padding: ${spacing.large};
    margin: -${spacing.large};
  `};
`

export default class BenefitsSlider extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }
  next() {
    this.slider.slickNext()
  }
  previous() {
    this.slider.slickPrev()
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      appendDots: dots => <Pagination>{dots}3</Pagination>,
      customPaging: function (i) {
        return <span>{i + 1}</span>
      }
    }
    return (
      <Container>
        <Slider ref={c => (this.slider = c)} {...settings}>
          <div>
            <Inner>
              <Heading as="span">
                <HeadingLabel>More choices</HeadingLabel>
              </Heading>
              <Description>
                Shop the full range of Vuse devices and flavours all in one place, and get access to exclusive products
                only available online, before they hit stores.
              </Description>
            </Inner>
          </div>
          <div>
            <Inner>
              <Heading as="span">
                <HeadingLabel>Ship how you want</HeadingLabel>
              </Heading>
              <Description>
                We offer free standard shipping on orders over $50. You can also choose express shipping, or have your
                orders delivered to the nearest post office for your convenience.
              </Description>
            </Inner>
          </div>
          <div>
            <Inner>
              <Heading as="span">
                <HeadingLabel>Earn rewards</HeadingLabel>
              </Heading>
              <Description>
                With Vuse+, a rewards program exclusively for vuse.com customers, get early access to exclusive offers,
                rewards, and early access to new products.
              </Description>
            </Inner>
          </div>
        </Slider>
        <ArrowWrap>
          <Arrow onClick={this.previous}>
            <Icon icon={<LeftChevron />} />
          </Arrow>
          <Arrow onClick={this.next}>
            <Icon icon={<RightChevron />} />
          </Arrow>
        </ArrowWrap>
      </Container>
    )
  }
}
